import React, { useState } from 'react';
import { GridContainer } from '../../global';
import { BannerContainer, BannerContent, BannerTitle, BannerIntro, ContactPageSection, TwoColumns, ContactInfo, FormContainer, FormIntroText, WhatsappButton, WhatsappSection } from './style';

const FaleConosco = () => {

  const [formData, setFormData] = useState({
    seuNome: '',
    phoneNumber: '',
    email: '',
    yourCompany: '',
    subject: '',
    mensagem: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

   
    const body = new URLSearchParams();

    body.append('Seu Nome', formData.seuNome);
    body.append('Phone Number', formData.phoneNumber);
    body.append('Email', formData.email);
    body.append('Your Company', formData.yourCompany);
    body.append('subject', formData.subject);
    body.append('Mensagem', formData.mensagem);


    body.append('email_to', 'rodrigo.garcia@renovera.com.br');
    body.append('website_form_signature', '8711b3d1205dd191b76a2148c9354822140e40fa3cde111a29b32d423552d413');
    body.append('email_from', 'renovera@renovera.com.br');
  

    try {
      const response = await fetch('https://renovera.com.br/website_form/mail.mail', {
        method: 'POST',
        headers: {
    
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: body.toString(),
      });

      if (response.ok) {
        alert('Mensagem enviada com sucesso!');

        setFormData({ seuNome: '', phoneNumber: '', email: '', yourCompany: '', subject: '', mensagem: '' });
      } else {
        const errorText = await response.text();
        alert('Houve um erro ao enviar a mensagem. Por favor, tente novamente.');
        console.error('Erro ao enviar o formulário:', response.status, errorText);
      }
    } catch (error) {
      alert('Houve um erro ao enviar a mensagem. Por favor, tente novamente.');
      console.error('Erro de rede ou de código:', error);
    }
  };
  
  const whatsappNumber = '5519996514827';
  const whatsappMessage = encodeURIComponent('Olá, poderia me ajudar ? ');
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  const address = "Rua Gabriel Ferreira, n.29, Sala 12 - Centro - São João da Boa Vista/SP - Cep: 13870-180";
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
  
  return (
    <>
      <BannerContainer>
        <BannerContent>
          <BannerTitle>Fale Conosco</BannerTitle>
          <BannerIntro>
            Nos envie uma mensagem e conte como podemos te ajudar! Caso tenha alguma dúvida, sugestão ou reclamação, fique a vontade para descrever na mensagem. Nosso consultor logo irá entrar em contato com você.
          </BannerIntro>
        </BannerContent>
        </BannerContainer>

      <ContactPageSection>
        <GridContainer>
          <TwoColumns>
            <FormContainer>
              <FormIntroText>
                Preencha os campos com as suas informações pessoais e profissionais para identificação.
              </FormIntroText>
              <form onSubmit={handleSubmit}>
                <label>
                  Seu nome*
                  <input type="text" name="seuNome" placeholder="Ex: José Almeida" value={formData.seuNome} onChange={handleChange} required />
                </label>
                <label>
                  Número de Telefone*
                  <input type="text" name="phoneNumber" placeholder="(00) 00000-0000" value={formData.phoneNumber} onChange={handleChange} required />
                </label>
                <label>
                  Email *
                  <input type="email" name="email" placeholder="Ex: jose@email.com.br" value={formData.email} onChange={handleChange} required />
                </label>
                <label>
                  Sua Empresa
                  <input type="text" name="yourCompany" placeholder="Nome da sua empresa" value={formData.yourCompany} onChange={handleChange} />
                </label>
                <label>
                  Assunto *
                  <input type="text" name="subject" placeholder="Sobre o que você gostaria de falar?" value={formData.subject} onChange={handleChange} required />
                </label>
                <label>
                  Mensagem *
                  <textarea name="mensagem" rows="6" placeholder="Digite sua mensagem aqui..." value={formData.mensagem} onChange={handleChange} required></textarea>
                </label>
                <button type="submit">Enviar</button>
              </form>
            </FormContainer>
            <ContactInfo>
              <h3>Informações de Contato</h3>
              <p>Sinta-se à vontade para nos contatar através dos canais abaixo.</p>

              <strong>E-mail</strong>
              <p><a href="mailto:renovera@renovera.com.br">renovera@renovera.com.br</a></p>

              <strong>Telefone</strong>
              <p> +55 (19) 99651-4827</p>

              <strong>Endereço</strong>
              <p>
                <a href={googleMapsUrl} target="_blank" rel="noopener noreferrer">
                  Rua Gabriel Ferreira, n.29, Sala 12<br/>Centro, São João da Boa Vista - SP<br/>CEP: 13870-180
                </a>
              </p>

              <WhatsappSection>
                <p>Se preferir entre em contato conosco através do WhatsApp.</p>
                <WhatsappButton href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                  Iniciar Conversa
                </WhatsappButton>
              </WhatsappSection>
            </ContactInfo>
          </TwoColumns>
        </GridContainer>
      </ContactPageSection>
    </>
  );
};

export default FaleConosco;